import React, { useState, useEffect } from "react";
import style from "./systemIdgenerator.module.css";
import axios from "axios";
import { Modal } from 'react-bootstrap';
import { BASE_URL } from "../../../constants/Constants";
import { useNavigate } from "react-router-dom";
import CompanyLogo from "../../../assets/images/brand/logo_2_107x70.png"
import { ErrorToast } from "../../../components/toastMessage";
import { Dialog } from "../../../components/CommonComponents/Dialog/Dialog";
import tickGreen from "../../../assets/images/gif/geentick.gif"
import tickRed from "../../../assets/images/gif/return.gif";
import { useUser } from "../../../contexts/UserContext";
import DialogConfirmation from "../../../components/CommonComponents/DialogConfirmation/DialogConfirmation";
import ActionDialog from "../../../components/CommonComponents/DialogConfirmation/ActionDialog";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import { _axios } from "../../../utils/axios";
import { AxiosError } from 'axios';

const SystemIdGenerator: React.FC = () => {
  const [prefix, setPrefix] = useState('');
  const [numberOfDigits, setNumberOfDigits] = useState(0);
  const [startSequence, setStartSequence] = useState('');
  const [formattedId, setFormattedId] = useState('');
  const [recordExists, setRecordExists] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [originalNumberOfDigits, setOriginalNumberOfDigits] = useState(0);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const navigate = useNavigate();
  const userObj = useUser();

  console.log("user ", userObj?.name);
  console.log("userId ", userObj?.user_id);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await _axios.get(`${BASE_URL}/api/systemId/checkExistence`);
        setRecordExists(response.data.exists);

        if (response.data.exists) {
          const systemIdResponse = await _axios.get(`${BASE_URL}/api/systemId/getSystemId`);
          const systemIdData = systemIdResponse.data.result;

          setPrefix(systemIdData.prefix);
          setNumberOfDigits(systemIdData.no_of_digits);
          setOriginalNumberOfDigits(systemIdData.no_of_digits);
          setStartSequence(systemIdData.start_seq);
          updateFormattedId(systemIdData);
          setIsPublished(true);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [recordExists]);

  const updateFormattedId = (systemIdData: { prefix: any; no_of_digits: any; start_seq: any; }) => {
    const { prefix, no_of_digits, start_seq } = systemIdData;
    const truncatedStartSeq = start_seq.toString().slice(-no_of_digits);
    const formattedId = `${prefix}-${truncatedStartSeq.padStart(no_of_digits, '0')}`;
    setFormattedId(formattedId);
  };

  const handleConfirmPublish = () => {
    setShowConfirmDialog(false);
    handlePublish();
  };

  const handlePublishClick = () => {
    if (numberOfDigits > originalNumberOfDigits) {
      setShowConfirmDialog(true);
    } else {
      handlePublish();
    }
  };

  const isAxiosError = (error: any): error is AxiosError => {
    return error.isAxiosError === true;
  };

  interface ErrorResponse {
    message: string;
  }

  const handlePublish = async () => {
    const data = {
      prefix,
      no_of_digits: numberOfDigits,
      start_seq: startSequence,
      modified_by: userObj?.name,
      user_id: userObj?.user_id,
    };

    try {
      const apiUrl = recordExists ? `${BASE_URL}/api/systemId/edit` : `${BASE_URL}/api/systemId/create`;
      const method = recordExists ? "patch" : "post";

      const response = await _axios[method](apiUrl, data);
      console.log(response.data);
      setLgShow(true);
      setError(null);
      setRecordExists(true);
      setIsPublished(true);
      setTimeout(() => {
        setLgShow(false);
        navigate('/dashboard');
      }, 3500);
    } catch (error: unknown) {
      if (isAxiosError(error) && error.response) {
        console.log(error.response.data);
        const errorData = error.response.data as ErrorResponse;
        const errorMessage = errorData.message || 'An error occurred';
        setError(errorMessage);
        ErrorToast(errorMessage);
      } else {
        console.error('Unexpected error', error);
        setError('An unexpected error occurred');
        ErrorToast('An unexpected error occurred');
      }
    }
  };

  const handlePrefixChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
    setPrefix(e.target.value);
    updateFormattedId({ prefix: e.target.value, no_of_digits: numberOfDigits, start_seq: startSequence });
  };

  const handleNumberOfDigitsChange = (e: { target: { value: string; }; }) => {
    setNumberOfDigits(parseInt(e.target.value, 10));
    updateFormattedId({ prefix, no_of_digits: parseInt(e.target.value, 10), start_seq: startSequence });
  };

  const handleStartSequenceChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
    setStartSequence(e.target.value);
    updateFormattedId({ prefix, no_of_digits: numberOfDigits, start_seq: e.target.value });
  };

  return (
    <div className={style.bodyBox}>
      <div className={style.bodyHeading}>
        <p className={style.bodyTitle}>Application ID Generator</p>
      </div>

      <BoxComponent>
        <div className={style.logoUploadContainer}>
          <div className={style.uploadsection}>
            <div className="appIdForm">
              <p className={style.bodyTitleNormal}>Application ID</p>

              <div className={style.formRow}>
                <div className={style.formGroup}>
                  <label className={style.subHeadingLabel}>Prefix</label>
                  <input
                    className={style.InputTxtNum}
                    type="text"
                    value={prefix}
                    onChange={handlePrefixChange}
                    maxLength={5}
                  />
                </div>

                <div className={style.formGroup}>
                  <label className={style.subHeadingLabel}>Number of Digits</label>
                  <input
                    className={style.InputTxtNum}
                    type="number"
                    value={numberOfDigits}
                    onChange={handleNumberOfDigitsChange}
                    min="0"
                    step="1"
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === '-' || e.key === '+' || e.key === '.') {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>

              <div className={style.formRow}>
                <div className={style.formGroup}>
                  <label className={style.subHeadingLabel}>Start Sequence</label>
                  <input
                    className={style.InputTxtNum}
                    type="text"
                    value={startSequence}
                    onChange={handleStartSequenceChange}
                    disabled={isPublished}
                  />
                </div>
                <div className={style.formGroup}>
                  <label className={style.subHeadingLabel}>Application ID Preview</label>
                  <input className={style.InputTxtNum} type="text" value={formattedId} disabled />
                </div>
              </div>

              {/* Button section for publish and close buttons */}
              <div className={style.buttonSection}>

                <button
                  className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300"
                  onClick={handlePublishClick}
                >
                  {recordExists ? 'Publish' : 'Publish'}
                </button>


                <button className="bg-black ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300" onClick={() => navigate('/dashboard')}>Close</button>
              </div>
            </div>
          </div>
        </div>
      </BoxComponent>

      {showConfirmDialog && (
        <DialogConfirmation
          title="Confirmation Required"
          description="The change (or increment) in number of digits once done cannot be undone i.e. rolled back or reduced. Do you still wish to continue with Publishing?"
          showConfirmDialog={showConfirmDialog}
          setShowConfirmDialog={setShowConfirmDialog}
          handleConfirmPublish={handleConfirmPublish}
        />
      )}

      <ActionDialog
        isOpen={lgShow}
        onClose={() => setLgShow(false)}
        actionType="approved"
        imageSrc={tickGreen}
        title="Publishing Customization"
        description="System is applying changes in background"
        navigateTo="/dashboard"
      />
      {/* Modal component */}

    </div>
  );
}

export default SystemIdGenerator;
